import './ThemeButton.scss';
import { useContext } from 'react';
import { ThemeContext } from '../../context';

export default function ThemeButton()
    {
        const { toggleTheme, theme} = useContext(ThemeContext)

        return(
            <div className="themeButton"
                onClick={
                        () =>{toggleTheme()}
                        }
            >
                <div className={`themeButtonRound_${theme}`}></div>
            </div>
        )
    }